
import Add from "../../../assets/outline/Add.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AddIcon({ className, dataTestid = "AddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Add data-testid={dataTestid} className={classes} {...rest} />
  );
}
